import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class ProjectFolderService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.PROJECT_FOLDER = '/api/project-folder';
        this.CREATE_FOLDER = '/create';
        this.CREATE_PERMISSION = '/create/permission';
        this.UPDATE = '/update';
        this.DELETE = '/delete';
        this.GET_BY_ID = '/{id}';
        this.GET_BY_PROJECT_ID = '/project/{projectId}';
        this.GET_BY_PARENT_ID = '/parent/{parentId}';
        this.GET_EXPORTS_FILE_LIST = '/export/file/{parentId}/{folderName}/{tableType}';
    }

    async getByParentId(parentId) {
        try {
            let url = window.location.origin + this.PROJECT_FOLDER + this.GET_BY_PARENT_ID;
            url = url
                .replace('{parentId}', parentId)
            const folderData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderData;
        } catch(err) {
            console.log(err);
        }
    }

    async getByProjectId(projectId) {
        try {
            let url = window.location.origin + this.PROJECT_FOLDER + this.GET_BY_PROJECT_ID;
            url = url
                .replace('{projectId}', projectId)
            const folderData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderData;
        } catch(err) {
            console.log(err);
        }
    }

    async getExportsFiles(parentId, folderName, tableType) {
        try {
            let url = window.location.origin + this.PROJECT_FOLDER + this.GET_EXPORTS_FILE_LIST;
            url = url
                .replace('{parentId}', parentId)
                .replace('{folderName}', folderName)
                .replace('{tableType}', tableType);
            const folderData = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderData;
        } catch(err) {
            console.log(err);
        }
    }

    async createProjectFolder(projectFolder) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_FOLDER + this.CREATE_FOLDER;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectFolder)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async createProjectFolderPermission(projectFolderPermission) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_FOLDER + this.CREATE_PERMISSION;
        try{
            return this.fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectFolderPermission)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async updateProjectFolder(projectFolder) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_FOLDER + this.UPDATE;
        try{
            return this.fetch(url, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectFolder)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }

    async deleteProjectFolder(projectFolder) {
        let csrfToken = Cookies.get('XSRF-TOKEN');
        let url = window.location.origin + this.PROJECT_FOLDER + this.DELETE;
        try{
            return this.fetch(url, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': csrfToken
                },
                body: JSON.stringify(projectFolder)
            }).then(data => data.json())
                .then(data => {
                    if(data.error !== undefined){
                        if(data.error === 'Session Expired') {
                            let userAuthService = new UserAuthService();
                            userAuthService.logout();
                        }
                        else {
                            localStorage.setItem('errorUUID', data.uuid);
                        }
                    }
                    return data;
                })
        } catch(err) {
            console.log(err);
        }
    }
}

export default ProjectFolderService;